module.exports = __webpack_public_path__ + "static/img/220.194.43.122.c26121b2.png";